"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _reactDeviceDetect = require("react-device-detect");
var _helper = require("./helper");
var _Tab = _interopRequireDefault(require("./Tab"));
var _TabPanel = _interopRequireDefault(require("./TabPanel"));
var _uuid = _interopRequireDefault(require("./uuid"));
var _jsxFileName = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tabs.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_nuuju9ebg() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tabs.js";
  var hash = "87fa563b010887f77112ab21cc631456743d197f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tabs.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 32
        },
        end: {
          line: 16,
          column: 58
        }
      },
      "2": {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 100
        }
      },
      "3": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 102
        }
      },
      "4": {
        start: {
          line: 34,
          column: 12
        },
        end: {
          line: 34,
          column: 82
        }
      },
      "5": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 87
        }
      },
      "6": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 42,
          column: 89
        }
      },
      "7": {
        start: {
          line: 57,
          column: 17
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "8": {
        start: {
          line: 64,
          column: 26
        },
        end: {
          line: 64,
          column: 57
        }
      },
      "9": {
        start: {
          line: 65,
          column: 30
        },
        end: {
          line: 65,
          column: 64
        }
      },
      "10": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 76,
          column: 34
        }
      },
      "11": {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 81,
          column: 27
        }
      },
      "12": {
        start: {
          line: 93,
          column: 26
        },
        end: {
          line: 93,
          column: 57
        }
      },
      "13": {
        start: {
          line: 94,
          column: 30
        },
        end: {
          line: 94,
          column: 64
        }
      },
      "14": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 71
        }
      },
      "15": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "16": {
        start: {
          line: 140,
          column: 31
        },
        end: {
          line: 158,
          column: 1
        }
      },
      "17": {
        start: {
          line: 162,
          column: 36
        },
        end: {
          line: 167,
          column: 4
        }
      },
      "18": {
        start: {
          line: 162,
          column: 59
        },
        end: {
          line: 167,
          column: 3
        }
      },
      "19": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 17
        }
      },
      "20": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 177,
          column: 6
        }
      },
      "21": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 178,
          column: 39
        }
      },
      "22": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 37
        }
      },
      "23": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 181,
          column: 65
        }
      },
      "24": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 30
        }
      },
      "25": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "26": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 43
        }
      },
      "27": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 65
        }
      },
      "28": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "29": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 195,
          column: 61
        }
      },
      "30": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 202,
          column: 5
        }
      },
      "31": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 43
        }
      },
      "32": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 208,
          column: 5
        }
      },
      "33": {
        start: {
          line: 207,
          column: 6
        },
        end: {
          line: 207,
          column: 68
        }
      },
      "34": {
        start: {
          line: 211,
          column: 12
        },
        end: {
          line: 237,
          column: 3
        }
      },
      "35": {
        start: {
          line: 212,
          column: 28
        },
        end: {
          line: 212,
          column: 30
        }
      },
      "36": {
        start: {
          line: 213,
          column: 27
        },
        end: {
          line: 213,
          column: 29
        }
      },
      "37": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 214,
          column: 23
        }
      },
      "38": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "39": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 18
        }
      },
      "40": {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 218,
          column: 35
        }
      },
      "41": {
        start: {
          line: 219,
          column: 30
        },
        end: {
          line: 219,
          column: 40
        }
      },
      "42": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      "43": {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 222,
          column: 27
        }
      },
      "44": {
        start: {
          line: 224,
          column: 6
        },
        end: {
          line: 226,
          column: 7
        }
      },
      "45": {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 225,
          column: 28
        }
      },
      "46": {
        start: {
          line: 228,
          column: 11
        },
        end: {
          line: 234,
          column: 5
        }
      },
      "47": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 27
        }
      },
      "48": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 233,
          column: 7
        }
      },
      "49": {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 232,
          column: 46
        }
      },
      "50": {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 235,
          column: 39
        }
      },
      "51": {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 16
        }
      },
      "52": {
        start: {
          line: 240,
          column: 27
        },
        end: {
          line: 240,
          column: 53
        }
      },
      "53": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 243,
          column: 5
        }
      },
      "54": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 53
        }
      },
      "55": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 255,
          column: 7
        }
      },
      "56": {
        start: {
          line: 245,
          column: 75
        },
        end: {
          line: 245,
          column: 86
        }
      },
      "57": {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 254,
          column: 8
        }
      },
      "58": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "59": {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 265,
          column: 41
        }
      },
      "60": {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 267,
          column: 39
        }
      },
      "61": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 273,
          column: 7
        }
      },
      "62": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 41
        }
      },
      "63": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 290,
          column: 5
        }
      },
      "64": {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 287,
          column: 37
        }
      },
      "65": {
        start: {
          line: 289,
          column: 6
        },
        end: {
          line: 289,
          column: 49
        }
      },
      "66": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 53
        }
      },
      "67": {
        start: {
          line: 298,
          column: 46
        },
        end: {
          line: 298,
          column: 53
        }
      },
      "68": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 31
        }
      },
      "69": {
        start: {
          line: 302,
          column: 20
        },
        end: {
          line: 302,
          column: 40
        }
      },
      "70": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 305,
          column: 5
        }
      },
      "71": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 304,
          column: 42
        }
      },
      "72": {
        start: {
          line: 306,
          column: 4
        },
        end: {
          line: 306,
          column: 28
        }
      },
      "73": {
        start: {
          line: 307,
          column: 4
        },
        end: {
          line: 311,
          column: 7
        }
      },
      "74": {
        start: {
          line: 317,
          column: 14
        },
        end: {
          line: 319,
          column: 3
        }
      },
      "75": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 25
        }
      },
      "76": {
        start: {
          line: 321,
          column: 31
        },
        end: {
          line: 321,
          column: 63
        }
      },
      "77": {
        start: {
          line: 321,
          column: 38
        },
        end: {
          line: 321,
          column: 63
        }
      },
      "78": {
        start: {
          line: 321,
          column: 60
        },
        end: {
          line: 321,
          column: 62
        }
      },
      "79": {
        start: {
          line: 336,
          column: 8
        },
        end: {
          line: 336,
          column: 18
        }
      },
      "80": {
        start: {
          line: 337,
          column: 32
        },
        end: {
          line: 337,
          column: 42
        }
      },
      "81": {
        start: {
          line: 338,
          column: 21
        },
        end: {
          line: 338,
          column: 35
        }
      },
      "82": {
        start: {
          line: 339,
          column: 29
        },
        end: {
          line: 339,
          column: 55
        }
      },
      "83": {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 360,
          column: 12
        }
      },
      "84": {
        start: {
          line: 343,
          column: 12
        },
        end: {
          line: 345,
          column: 13
        }
      },
      "85": {
        start: {
          line: 344,
          column: 14
        },
        end: {
          line: 344,
          column: 26
        }
      },
      "86": {
        start: {
          line: 346,
          column: 12
        },
        end: {
          line: 348,
          column: 13
        }
      },
      "87": {
        start: {
          line: 347,
          column: 14
        },
        end: {
          line: 347,
          column: 26
        }
      },
      "88": {
        start: {
          line: 349,
          column: 12
        },
        end: {
          line: 358,
          column: 14
        }
      },
      "89": {
        start: {
          line: 355,
          column: 35
        },
        end: {
          line: 355,
          column: 51
        }
      },
      "90": {
        start: {
          line: 361,
          column: 4
        },
        end: {
          line: 393,
          column: 6
        }
      },
      "91": {
        start: {
          line: 369,
          column: 24
        },
        end: {
          line: 369,
          column: 39
        }
      },
      "92": {
        start: {
          line: 372,
          column: 12
        },
        end: {
          line: 385,
          column: 14
        }
      },
      "93": {
        start: {
          line: 397,
          column: 0
        },
        end: {
          line: 433,
          column: 2
        }
      },
      "94": {
        start: {
          line: 435,
          column: 0
        },
        end: {
          line: 454,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 16
          }
        },
        loc: {
          start: {
            line: 16,
            column: 32
          },
          end: {
            line: 16,
            column: 58
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 17
          },
          end: {
            line: 24,
            column: 18
          }
        },
        loc: {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 25,
            column: 100
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 30
          },
          end: {
            line: 27,
            column: 31
          }
        },
        loc: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 102
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 30
          },
          end: {
            line: 33,
            column: 31
          }
        },
        loc: {
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 34,
            column: 82
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 19
          },
          end: {
            line: 38,
            column: 20
          }
        },
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 87
          }
        },
        line: 39
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 32
          },
          end: {
            line: 41,
            column: 33
          }
        },
        loc: {
          start: {
            line: 42,
            column: 14
          },
          end: {
            line: 42,
            column: 89
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 17
          }
        },
        loc: {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 57
          }
        },
        line: 64
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 65,
            column: 21
          }
        },
        loc: {
          start: {
            line: 65,
            column: 30
          },
          end: {
            line: 65,
            column: 64
          }
        },
        line: 65
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 76,
            column: 34
          }
        },
        line: 72
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 78,
            column: 10
          },
          end: {
            line: 78,
            column: 11
          }
        },
        loc: {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 81,
            column: 27
          }
        },
        line: 79
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 93,
            column: 17
          }
        },
        loc: {
          start: {
            line: 93,
            column: 26
          },
          end: {
            line: 93,
            column: 57
          }
        },
        line: 93
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 94,
            column: 20
          },
          end: {
            line: 94,
            column: 21
          }
        },
        loc: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 94,
            column: 64
          }
        },
        line: 94
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 101,
            column: 26
          },
          end: {
            line: 101,
            column: 27
          }
        },
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 71
          }
        },
        line: 102
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        },
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        },
        line: 105
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 162,
            column: 36
          },
          end: {
            line: 162,
            column: 37
          }
        },
        loc: {
          start: {
            line: 162,
            column: 59
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 162
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 169,
            column: 3
          }
        },
        loc: {
          start: {
            line: 169,
            column: 21
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 169
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 184,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        },
        loc: {
          start: {
            line: 184,
            column: 22
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 184
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 193,
            column: 2
          },
          end: {
            line: 193,
            column: 3
          }
        },
        loc: {
          start: {
            line: 193,
            column: 44
          },
          end: {
            line: 203,
            column: 3
          }
        },
        line: 193
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 205,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        },
        loc: {
          start: {
            line: 205,
            column: 25
          },
          end: {
            line: 209,
            column: 3
          }
        },
        line: 205
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 211,
            column: 12
          },
          end: {
            line: 211,
            column: 13
          }
        },
        loc: {
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 211
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 239,
            column: 2
          },
          end: {
            line: 239,
            column: 3
          }
        },
        loc: {
          start: {
            line: 239,
            column: 12
          },
          end: {
            line: 256,
            column: 3
          }
        },
        line: 239
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 244,
            column: 35
          },
          end: {
            line: 244,
            column: 36
          }
        },
        loc: {
          start: {
            line: 244,
            column: 53
          },
          end: {
            line: 255,
            column: 5
          }
        },
        line: 244
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 263,
            column: 2
          },
          end: {
            line: 263,
            column: 3
          }
        },
        loc: {
          start: {
            line: 263,
            column: 24
          },
          end: {
            line: 268,
            column: 3
          }
        },
        line: 263
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 270,
            column: 2
          },
          end: {
            line: 270,
            column: 3
          }
        },
        loc: {
          start: {
            line: 270,
            column: 34
          },
          end: {
            line: 274,
            column: 3
          }
        },
        line: 270
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 276,
            column: 2
          },
          end: {
            line: 276,
            column: 3
          }
        },
        loc: {
          start: {
            line: 276,
            column: 23
          },
          end: {
            line: 278,
            column: 3
          }
        },
        line: 276
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 285,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        },
        loc: {
          start: {
            line: 285,
            column: 21
          },
          end: {
            line: 291,
            column: 3
          }
        },
        line: 285
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 3
          }
        },
        loc: {
          start: {
            line: 297,
            column: 21
          },
          end: {
            line: 312,
            column: 3
          }
        },
        line: 297
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 317,
            column: 14
          },
          end: {
            line: 317,
            column: 15
          }
        },
        loc: {
          start: {
            line: 317,
            column: 20
          },
          end: {
            line: 319,
            column: 3
          }
        },
        line: 317
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 321,
            column: 31
          },
          end: {
            line: 321,
            column: 32
          }
        },
        loc: {
          start: {
            line: 321,
            column: 38
          },
          end: {
            line: 321,
            column: 63
          }
        },
        line: 321
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 321,
            column: 54
          },
          end: {
            line: 321,
            column: 55
          }
        },
        loc: {
          start: {
            line: 321,
            column: 60
          },
          end: {
            line: 321,
            column: 62
          }
        },
        line: 321
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 323,
            column: 2
          },
          end: {
            line: 323,
            column: 3
          }
        },
        loc: {
          start: {
            line: 323,
            column: 11
          },
          end: {
            line: 394,
            column: 3
          }
        },
        line: 323
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 342,
            column: 23
          },
          end: {
            line: 342,
            column: 24
          }
        },
        loc: {
          start: {
            line: 342,
            column: 31
          },
          end: {
            line: 359,
            column: 11
          }
        },
        line: 342
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 355,
            column: 29
          },
          end: {
            line: 355,
            column: 30
          }
        },
        loc: {
          start: {
            line: 355,
            column: 35
          },
          end: {
            line: 355,
            column: 51
          }
        },
        line: 355
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 369,
            column: 19
          },
          end: {
            line: 369,
            column: 20
          }
        },
        loc: {
          start: {
            line: 369,
            column: 24
          },
          end: {
            line: 369,
            column: 39
          }
        },
        line: 369
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 371,
            column: 24
          },
          end: {
            line: 371,
            column: 25
          }
        },
        loc: {
          start: {
            line: 372,
            column: 12
          },
          end: {
            line: 385,
            column: 14
          }
        },
        line: 372
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 436,
            column: 12
          },
          end: {
            line: 436,
            column: 13
          }
        },
        loc: {
          start: {
            line: 436,
            column: 18
          },
          end: {
            line: 436,
            column: 20
          }
        },
        line: 436
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 25,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 16
          }
        }, {
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 31
          }
        }, {
          start: {
            line: 25,
            column: 35
          },
          end: {
            line: 25,
            column: 51
          }
        }, {
          start: {
            line: 25,
            column: 55
          },
          end: {
            line: 25,
            column: 86
          }
        }, {
          start: {
            line: 25,
            column: 91
          },
          end: {
            line: 25,
            column: 100
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 18
          }
        }, {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 33
          }
        }, {
          start: {
            line: 28,
            column: 37
          },
          end: {
            line: 28,
            column: 53
          }
        }, {
          start: {
            line: 28,
            column: 57
          },
          end: {
            line: 28,
            column: 88
          }
        }, {
          start: {
            line: 28,
            column: 93
          },
          end: {
            line: 28,
            column: 102
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 34,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 34,
            column: 17
          }
        }, {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 32
          }
        }, {
          start: {
            line: 34,
            column: 36
          },
          end: {
            line: 34,
            column: 52
          }
        }, {
          start: {
            line: 34,
            column: 56
          },
          end: {
            line: 34,
            column: 82
          }
        }],
        line: 34
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 17
          }
        }, {
          start: {
            line: 39,
            column: 21
          },
          end: {
            line: 39,
            column: 32
          }
        }, {
          start: {
            line: 39,
            column: 36
          },
          end: {
            line: 39,
            column: 52
          }
        }, {
          start: {
            line: 39,
            column: 56
          },
          end: {
            line: 39,
            column: 87
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 42,
            column: 14
          },
          end: {
            line: 42,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 14
          },
          end: {
            line: 42,
            column: 19
          }
        }, {
          start: {
            line: 42,
            column: 23
          },
          end: {
            line: 42,
            column: 34
          }
        }, {
          start: {
            line: 42,
            column: 38
          },
          end: {
            line: 42,
            column: 54
          }
        }, {
          start: {
            line: 42,
            column: 58
          },
          end: {
            line: 42,
            column: 89
          }
        }],
        line: 42
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 43
          },
          end: {
            line: 64,
            column: 51
          }
        }, {
          start: {
            line: 64,
            column: 54
          },
          end: {
            line: 64,
            column: 57
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 65,
            column: 30
          },
          end: {
            line: 65,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 47
          },
          end: {
            line: 65,
            column: 55
          }
        }, {
          start: {
            line: 65,
            column: 58
          },
          end: {
            line: 65,
            column: 64
          }
        }],
        line: 65
      },
      "7": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 76,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 13
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 41
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 19
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 24
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 34
          }
        }],
        line: 72
      },
      "8": {
        loc: {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 81,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 14
          },
          end: {
            line: 80,
            column: 76
          }
        }, {
          start: {
            line: 81,
            column: 14
          },
          end: {
            line: 81,
            column: 27
          }
        }],
        line: 79
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 14
          },
          end: {
            line: 80,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 15
          },
          end: {
            line: 80,
            column: 30
          }
        }, {
          start: {
            line: 80,
            column: 34
          },
          end: {
            line: 80,
            column: 62
          }
        }, {
          start: {
            line: 80,
            column: 67
          },
          end: {
            line: 80,
            column: 76
          }
        }],
        line: 80
      },
      "10": {
        loc: {
          start: {
            line: 93,
            column: 26
          },
          end: {
            line: 93,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 93,
            column: 43
          },
          end: {
            line: 93,
            column: 51
          }
        }, {
          start: {
            line: 93,
            column: 54
          },
          end: {
            line: 93,
            column: 57
          }
        }],
        line: 93
      },
      "11": {
        loc: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 94,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 47
          },
          end: {
            line: 94,
            column: 55
          }
        }, {
          start: {
            line: 94,
            column: 58
          },
          end: {
            line: 94,
            column: 64
          }
        }],
        line: 94
      },
      "12": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 41
          }
        }, {
          start: {
            line: 102,
            column: 45
          },
          end: {
            line: 102,
            column: 71
          }
        }],
        line: 102
      },
      "13": {
        loc: {
          start: {
            line: 104,
            column: 40
          },
          end: {
            line: 104,
            column: 62
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 104,
            column: 56
          },
          end: {
            line: 104,
            column: 62
          }
        }],
        line: 104
      },
      "14": {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 105,
            column: 17
          }
        }, {
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        }],
        line: 105
      },
      "15": {
        loc: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 18
          }
        }, {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }],
        line: 129
      },
      "16": {
        loc: {
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 187
      },
      "17": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 194
      },
      "18": {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 30
          }
        }, {
          start: {
            line: 194,
            column: 34
          },
          end: {
            line: 194,
            column: 90
          }
        }],
        line: 194
      },
      "19": {
        loc: {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 197
      },
      "20": {
        loc: {
          start: {
            line: 198,
            column: 6
          },
          end: {
            line: 199,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 6
          },
          end: {
            line: 198,
            column: 39
          }
        }, {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 199,
            column: 64
          }
        }],
        line: 198
      },
      "21": {
        loc: {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 208,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 208,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 206
      },
      "22": {
        loc: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 217,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 217,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 215
      },
      "23": {
        loc: {
          start: {
            line: 215,
            column: 8
          },
          end: {
            line: 215,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 215,
            column: 8
          },
          end: {
            line: 215,
            column: 37
          }
        }, {
          start: {
            line: 215,
            column: 41
          },
          end: {
            line: 215,
            column: 69
          }
        }],
        line: 215
      },
      "24": {
        loc: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 221
      },
      "25": {
        loc: {
          start: {
            line: 224,
            column: 6
          },
          end: {
            line: 226,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 224,
            column: 6
          },
          end: {
            line: 226,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 224
      },
      "26": {
        loc: {
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 228
      },
      "27": {
        loc: {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 233,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 233,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 231
      },
      "28": {
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 241
      },
      "29": {
        loc: {
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 264
      },
      "30": {
        loc: {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        }, {
          start: {
            line: 288,
            column: 11
          },
          end: {
            line: 290,
            column: 5
          }
        }],
        line: 286
      },
      "31": {
        loc: {
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 298,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 298,
            column: 53
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 298
      },
      "32": {
        loc: {
          start: {
            line: 303,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 303,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 303
      },
      "33": {
        loc: {
          start: {
            line: 321,
            column: 38
          },
          end: {
            line: 321,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 321,
            column: 38
          },
          end: {
            line: 321,
            column: 41
          }
        }, {
          start: {
            line: 321,
            column: 45
          },
          end: {
            line: 321,
            column: 63
          }
        }],
        line: 321
      },
      "34": {
        loc: {
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 360,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 342,
            column: 10
          },
          end: {
            line: 359,
            column: 12
          }
        }, {
          start: {
            line: 360,
            column: 10
          },
          end: {
            line: 360,
            column: 12
          }
        }],
        line: 341
      },
      "35": {
        loc: {
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 345,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 345,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 343
      },
      "36": {
        loc: {
          start: {
            line: 346,
            column: 12
          },
          end: {
            line: 348,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 346,
            column: 12
          },
          end: {
            line: 348,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 346
      },
      "37": {
        loc: {
          start: {
            line: 346,
            column: 16
          },
          end: {
            line: 346,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 346,
            column: 16
          },
          end: {
            line: 346,
            column: 29
          }
        }, {
          start: {
            line: 346,
            column: 33
          },
          end: {
            line: 346,
            column: 58
          }
        }, {
          start: {
            line: 346,
            column: 62
          },
          end: {
            line: 346,
            column: 74
          }
        }],
        line: 346
      },
      "38": {
        loc: {
          start: {
            line: 383,
            column: 25
          },
          end: {
            line: 383,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 383,
            column: 58
          },
          end: {
            line: 383,
            column: 72
          }
        }, {
          start: {
            line: 383,
            column: 75
          },
          end: {
            line: 383,
            column: 79
          }
        }],
        line: 383
      },
      "39": {
        loc: {
          start: {
            line: 388,
            column: 9
          },
          end: {
            line: 390,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 388,
            column: 9
          },
          end: {
            line: 388,
            column: 57
          }
        }, {
          start: {
            line: 389,
            column: 10
          },
          end: {
            line: 389,
            column: 76
          }
        }],
        line: 388
      },
      "40": {
        loc: {
          start: {
            line: 391,
            column: 9
          },
          end: {
            line: 391,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 391,
            column: 28
          },
          end: {
            line: 391,
            column: 59
          }
        }, {
          start: {
            line: 391,
            column: 62
          },
          end: {
            line: 391,
            column: 75
          }
        }],
        line: 391
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0, 0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "87fa563b010887f77112ab21cc631456743d197f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nuuju9ebg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nuuju9ebg();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_nuuju9ebg().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(_ref) {
    var tabMode = _ref.tabMode;
    cov_nuuju9ebg().f[0]++;
    cov_nuuju9ebg().s[1]++;
    return "g-Tabs g-Tabs-".concat(tabMode);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      position: relative;\n\n      .g-Tabs-link {\n        color: ", ";\n        :after {\n          background-color: ", ";\n        }\n      }\n      &.g-Tabs-BLOCK {\n        .g-Tabs-list {\n          background-color: ", ";\n          border-bottom: none;\n        }\n        .g-Tabs-link {\n          color: ", ";\n          &:after {\n            background-color: ", ";\n          }\n        }\n      }\n    "])), function (props) {
  cov_nuuju9ebg().f[1]++;
  cov_nuuju9ebg().s[2]++;
  return (cov_nuuju9ebg().b[0][0]++, props) && (cov_nuuju9ebg().b[0][1]++, props.theme) && (cov_nuuju9ebg().b[0][2]++, props.theme.tabs) && (cov_nuuju9ebg().b[0][3]++, props.theme.tabs.blockTextColor) || (cov_nuuju9ebg().b[0][4]++, '#00a6dc');
}, function (props) {
  cov_nuuju9ebg().f[2]++;
  cov_nuuju9ebg().s[3]++;
  return (cov_nuuju9ebg().b[1][0]++, props) && (cov_nuuju9ebg().b[1][1]++, props.theme) && (cov_nuuju9ebg().b[1][2]++, props.theme.tabs) && (cov_nuuju9ebg().b[1][3]++, props.theme.tabs.blockTextColor) || (cov_nuuju9ebg().b[1][4]++, '#00a6dc');
}, function (props) {
  cov_nuuju9ebg().f[3]++;
  cov_nuuju9ebg().s[4]++;
  return (cov_nuuju9ebg().b[2][0]++, props) && (cov_nuuju9ebg().b[2][1]++, props.theme) && (cov_nuuju9ebg().b[2][2]++, props.theme.tabs) && (cov_nuuju9ebg().b[2][3]++, props.theme.tabs.textColor);
}, function (props) {
  cov_nuuju9ebg().f[4]++;
  cov_nuuju9ebg().s[5]++;
  return (cov_nuuju9ebg().b[3][0]++, props) && (cov_nuuju9ebg().b[3][1]++, props.theme) && (cov_nuuju9ebg().b[3][2]++, props.theme.tabs) && (cov_nuuju9ebg().b[3][3]++, props.theme.tabs.blockTextColor);
}, function (props) {
  cov_nuuju9ebg().f[5]++;
  cov_nuuju9ebg().s[6]++;
  return (cov_nuuju9ebg().b[4][0]++, props) && (cov_nuuju9ebg().b[4][1]++, props.theme) && (cov_nuuju9ebg().b[4][2]++, props.theme.tabs) && (cov_nuuju9ebg().b[4][3]++, props.theme.tabs.blockTextColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      position: relative;\n      .g-Tabs-link.g-Tabs-link-text:hover {\n        text-decoration: none;\n      }\n    "]))))));
var TabsList = (cov_nuuju9ebg().s[7]++, (0, _utils.withThemedStyles)(_styledComponents.default.ul.attrs({
  className: 'g-Tabs-list',
  role: 'tablist'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      margin: ", ";\n      text-align: ", ";\n      padding: 0 1rem;\n      box-sizing: border-box;\n      display: block;\n      width: 100%;\n      white-space: normal;\n      background-color: ", ";\n      border-bottom: 1px solid\n        ", ";\n      @media only screen and (max-device-width: 40rem) {\n        white-space: nowrap;\n        overflow-x: auto;\n        overflow-y: hidden;\n      }\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    "])), function (props) {
  cov_nuuju9ebg().f[6]++;
  cov_nuuju9ebg().s[8]++;
  return props.centered ? (cov_nuuju9ebg().b[5][0]++, '0 auto') : (cov_nuuju9ebg().b[5][1]++, '0');
}, function (props) {
  cov_nuuju9ebg().f[7]++;
  cov_nuuju9ebg().s[9]++;
  return props.centered ? (cov_nuuju9ebg().b[6][0]++, 'center') : (cov_nuuju9ebg().b[6][1]++, 'left');
}, function (props) {
  cov_nuuju9ebg().f[8]++;
  cov_nuuju9ebg().s[10]++;
  return (cov_nuuju9ebg().b[7][0]++, props) && (cov_nuuju9ebg().b[7][1]++, props.useMainTitleBackgroundColor) && (cov_nuuju9ebg().b[7][2]++, props.theme) && (cov_nuuju9ebg().b[7][3]++, props.theme.tabs) && (cov_nuuju9ebg().b[7][4]++, props.theme.tabs.textColor);
}, function (props) {
  cov_nuuju9ebg().f[9]++;
  cov_nuuju9ebg().s[11]++;
  return !props.noBorder ? (cov_nuuju9ebg().b[8][0]++, (cov_nuuju9ebg().b[9][0]++, props.theme.tab) && (cov_nuuju9ebg().b[9][1]++, props.theme.tab.dividerColor) || (cov_nuuju9ebg().b[9][2]++, '#ebeff4')) : (cov_nuuju9ebg().b[8][1]++, 'transparent');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      margin: ", ";\n      text-align: ", ";\n      box-sizing: border-box;\n      display: block;\n      width: 100%;\n      white-space: nowrap;\n      overflow-x: auto;\n      overflow-y: hidden;\n      background-color: ", ";\n\n      ", ";\n\n      ", ";\n    "])), function (props) {
  cov_nuuju9ebg().f[10]++;
  cov_nuuju9ebg().s[12]++;
  return props.centered ? (cov_nuuju9ebg().b[10][0]++, '0 auto') : (cov_nuuju9ebg().b[10][1]++, '0');
}, function (props) {
  cov_nuuju9ebg().f[11]++;
  cov_nuuju9ebg().s[13]++;
  return props.centered ? (cov_nuuju9ebg().b[11][0]++, 'center') : (cov_nuuju9ebg().b[11][1]++, 'left');
}, function (props) {
  cov_nuuju9ebg().f[12]++;
  cov_nuuju9ebg().s[14]++;
  return (cov_nuuju9ebg().b[12][0]++, props.useMainTitleBackgroundColor) && (cov_nuuju9ebg().b[12][1]++, props.theme.tabs.textColor);
}, function (_ref2) {
  var noBorder = _ref2.noBorder,
    _ref2$activeBorderRan = _ref2.activeBorderRange,
    _ref2$activeBorderRan2 = _ref2$activeBorderRan === void 0 ? (cov_nuuju9ebg().b[13][0]++, [0, 0]) : _ref2$activeBorderRan,
    _ref2$activeBorderRan3 = (0, _slicedToArray2.default)(_ref2$activeBorderRan2, 2),
    start = _ref2$activeBorderRan3[0],
    size = _ref2$activeBorderRan3[1];
  cov_nuuju9ebg().f[13]++;
  cov_nuuju9ebg().s[15]++;
  return (cov_nuuju9ebg().b[14][0]++, !noBorder) && (cov_nuuju9ebg().b[14][1]++, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          --activeColor: var(--selectedTabTextColor, #2f2b43);\n          position: relative;\n\n          > li.g-Tabs-item {\n            border-bottom: var(--dividerWidth) solid var(--dividerColor);\n            transition: border-color 0.5s ease-in-out;\n            :hover {\n              border-color: var(--activeColor);\n            }\n          }\n\n          ::after {\n            content: ' ';\n            position: absolute;\n            transition: left 0.3s ease-in-out, width 0.3s;\n            border-bottom: var(--dividerWidth) solid var(--selectedTabTextColor);\n            bottom: 0;\n            left: ", "px;\n            width: ", "px;\n          }\n        "])), start, size));
}, (cov_nuuju9ebg().b[15][0]++, !_reactDeviceDetect.isDesktop) && (cov_nuuju9ebg().b[15][1]++, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n          &::-webkit-scrollbar {\n            display: none;\n          }\n        "])))))), {
  useForwardRef: true
}));
var AdditionalChildWrapper = (cov_nuuju9ebg().s[16]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-Tabs-AdditionalChild"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      padding-top: 1rem;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      padding-top: 0;\n      .g-FilterBar {\n        border-radius: 0;\n        box-shadow: none;\n        padding: 24px 0;\n        padding-bottom: 0;\n      }\n    "]))))));

/** A component to display tabs. It will display click on the top and elementi n the container will adapt accordingly */
var Tabs = /*#__PURE__*/function (_Component) {
  function Tabs(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Tabs);
    cov_nuuju9ebg().f[15]++;
    cov_nuuju9ebg().s[19]++;
    _this = _callSuper(this, Tabs, [props]);
    (0, _defineProperty2.default)(_this, "onKeyUp", (cov_nuuju9ebg().s[34]++, function (e) {
      cov_nuuju9ebg().f[19]++;
      var RIGHT_ARROW_KEY = (cov_nuuju9ebg().s[35]++, 39);
      var LEFT_ARROW_KEY = (cov_nuuju9ebg().s[36]++, 37);
      cov_nuuju9ebg().s[37]++;
      e.preventDefault();
      cov_nuuju9ebg().s[38]++;
      if ((cov_nuuju9ebg().b[23][0]++, e.keyCode !== RIGHT_ARROW_KEY) && (cov_nuuju9ebg().b[23][1]++, e.keyCode !== LEFT_ARROW_KEY)) {
        cov_nuuju9ebg().b[22][0]++;
        cov_nuuju9ebg().s[39]++;
        return null;
      } else {
        cov_nuuju9ebg().b[22][1]++;
      }
      var tabItems = (cov_nuuju9ebg().s[40]++, _this.getTabs());
      var _ref3 = (cov_nuuju9ebg().s[41]++, _this.state),
        focusedTabIndex = _ref3.focusedTabIndex;
      // Move right
      cov_nuuju9ebg().s[42]++;
      if (e.keyCode === RIGHT_ARROW_KEY) {
        cov_nuuju9ebg().b[24][0]++;
        cov_nuuju9ebg().s[43]++;
        focusedTabIndex += 1;
        // If we're at the end, go to the start
        cov_nuuju9ebg().s[44]++;
        if (focusedTabIndex >= tabItems.length) {
          cov_nuuju9ebg().b[25][0]++;
          cov_nuuju9ebg().s[45]++;
          focusedTabIndex = 0;
        } else {
          cov_nuuju9ebg().b[25][1]++;
        }
        // Move left
      } else {
        cov_nuuju9ebg().b[24][1]++;
        cov_nuuju9ebg().s[46]++;
        if (e.keyCode === LEFT_ARROW_KEY) {
          cov_nuuju9ebg().b[26][0]++;
          cov_nuuju9ebg().s[47]++;
          focusedTabIndex -= 1;
          // If we're at the start, move to the end
          cov_nuuju9ebg().s[48]++;
          if (focusedTabIndex < 0) {
            cov_nuuju9ebg().b[27][0]++;
            cov_nuuju9ebg().s[49]++;
            focusedTabIndex = tabItems.length - 1;
          } else {
            cov_nuuju9ebg().b[27][1]++;
          }
        } else {
          cov_nuuju9ebg().b[26][1]++;
        }
      }
      cov_nuuju9ebg().s[50]++;
      _this.setState({
        focusedTabIndex: focusedTabIndex
      });
      cov_nuuju9ebg().s[51]++;
      return null;
    }));
    /**
     * Hide the tabs, and reset the selectedTabIndex to remove the previous selection over the tab
     */
    (0, _defineProperty2.default)(_this, "closeTabs", (cov_nuuju9ebg().s[74]++, function () {
      cov_nuuju9ebg().f[27]++;
      cov_nuuju9ebg().s[75]++;
      _this.tabSelected(-1);
    }));
    (0, _defineProperty2.default)(_this, "isArrayContainNotNullValue", (cov_nuuju9ebg().s[76]++, function (arr) {
      cov_nuuju9ebg().f[28]++;
      cov_nuuju9ebg().s[77]++;
      return (cov_nuuju9ebg().b[33][0]++, arr) && (cov_nuuju9ebg().b[33][1]++, arr.some(function (el) {
        cov_nuuju9ebg().f[29]++;
        cov_nuuju9ebg().s[78]++;
        return el;
      }));
    }));
    cov_nuuju9ebg().s[20]++;
    _this.state = {
      selectedTabIndex: props.selectedTabIndex,
      activeBorderRange: [0, 0],
      // for optimization purpose, only generate tabs that are the current tab or has already been displayed
      shownTabs: [props.selectedTabIndex],
      focusedTabIndex: props.selectedTabIndex
    };
    cov_nuuju9ebg().s[21]++;
    _this.activeTab = /*#__PURE__*/_react.default.createRef();
    cov_nuuju9ebg().s[22]++;
    _this.tabsRef = /*#__PURE__*/_react.default.createRef();
    cov_nuuju9ebg().s[23]++;
    _this.handleWindowChange = _this.handleWindowChange.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(Tabs, _Component);
  return (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_nuuju9ebg().f[16]++;
      cov_nuuju9ebg().s[24]++;
      this.id = (0, _uuid.default)('g-Tabs');
      cov_nuuju9ebg().s[25]++;
      if (this.props.themeQueries.EVOLUTION) {
        cov_nuuju9ebg().b[16][0]++;
        cov_nuuju9ebg().s[26]++;
        this.handleActiveBorderRangeChange();
        cov_nuuju9ebg().s[27]++;
        window.addEventListener('resize', this.handleWindowChange);
      } else {
        cov_nuuju9ebg().b[16][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      cov_nuuju9ebg().f[17]++;
      cov_nuuju9ebg().s[28]++;
      if ((cov_nuuju9ebg().b[18][0]++, this.activeTab.current) && (cov_nuuju9ebg().b[18][1]++, prevState.focusedTabIndex !== this.state.focusedTabIndex)) {
        cov_nuuju9ebg().b[17][0]++;
        cov_nuuju9ebg().s[29]++;
        this.activeTab.current.focus({
          preventScroll: false
        });
      } else {
        cov_nuuju9ebg().b[17][1]++;
      }
      cov_nuuju9ebg().s[30]++;
      if ((cov_nuuju9ebg().b[20][0]++, this.props.themeQueries.EVOLUTION) && (cov_nuuju9ebg().b[20][1]++, this.state.selectedTabIndex !== prevState.selectedTabIndex)) {
        cov_nuuju9ebg().b[19][0]++;
        cov_nuuju9ebg().s[31]++;
        this.handleActiveBorderRangeChange();
      } else {
        cov_nuuju9ebg().b[19][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_nuuju9ebg().f[18]++;
      cov_nuuju9ebg().s[32]++;
      if (this.props.themeQueries.EVOLUTION) {
        cov_nuuju9ebg().b[21][0]++;
        cov_nuuju9ebg().s[33]++;
        window.removeEventListener('resize', this.handleWindowChange);
      } else {
        cov_nuuju9ebg().b[21][1]++;
      }
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      cov_nuuju9ebg().f[20]++;
      var selectedTabIndex = (cov_nuuju9ebg().s[52]++, this.getSelectedTabIndex());
      cov_nuuju9ebg().s[53]++;
      if (this.props.onTabsChange) {
        cov_nuuju9ebg().b[28][0]++;
        cov_nuuju9ebg().s[54]++;
        selectedTabIndex = this.props.selectedTabIndex;
      } else {
        cov_nuuju9ebg().b[28][1]++;
      }
      cov_nuuju9ebg().s[55]++;
      return this.props.children.map(function (child, index) {
        cov_nuuju9ebg().f[21]++;
        var _ref4 = (cov_nuuju9ebg().s[56]++, child.props),
          label = _ref4.label,
          disabled = _ref4.disabled,
          tabType = _ref4.tabType,
          content = _ref4.children,
          buttonProps = _ref4.buttonProps;
        cov_nuuju9ebg().s[57]++;
        return {
          index: index,
          label: label,
          active: selectedTabIndex === index,
          disabled: disabled,
          tabType: tabType,
          content: content,
          buttonProps: buttonProps
        };
      });
    }

    /**
     * Return the selected index from props or state. This depends if we pass
     * by props the method 'onTabsChange', in this case, it will means that the
     * selected index comes from props not from state
     */
  }, {
    key: "getSelectedTabIndex",
    value: function getSelectedTabIndex() {
      cov_nuuju9ebg().f[22]++;
      cov_nuuju9ebg().s[58]++;
      if (this.props.onTabsChange) {
        cov_nuuju9ebg().b[29][0]++;
        cov_nuuju9ebg().s[59]++;
        return this.props.selectedTabIndex;
      } else {
        cov_nuuju9ebg().b[29][1]++;
      }
      cov_nuuju9ebg().s[60]++;
      return this.state.selectedTabIndex;
    }
  }, {
    key: "handleActiveBorderRangeChange",
    value: function handleActiveBorderRangeChange() {
      cov_nuuju9ebg().f[23]++;
      cov_nuuju9ebg().s[61]++;
      this.setState({
        activeBorderRange: (0, _helper.getActiveBorderRange)(this.getTabs(), this.tabsRef.current)
      });
    }
  }, {
    key: "handleWindowChange",
    value: function handleWindowChange() {
      cov_nuuju9ebg().f[24]++;
      cov_nuuju9ebg().s[62]++;
      this.handleActiveBorderRangeChange();
    }

    /**
     * If we need to know outside the component that a tab has been clicked (when the
     * props 'onTabChange' exists) will be propagated to upper, else, will set the index
     * @param {number} index, tab index to be selected
     */
  }, {
    key: "tabSelected",
    value: function tabSelected(index) {
      cov_nuuju9ebg().f[25]++;
      cov_nuuju9ebg().s[63]++;
      if (this.props.onTabsChange) {
        cov_nuuju9ebg().b[30][0]++;
        cov_nuuju9ebg().s[64]++;
        this.props.onTabsChange(index);
      } else {
        cov_nuuju9ebg().b[30][1]++;
        cov_nuuju9ebg().s[65]++;
        this.setState({
          selectedTabIndex: index
        });
      }
    }

    /**
     * Select a tab, always the tab is not active
     * @param {number} index, tab index to select
     */
  }, {
    key: "handleClick",
    value: function handleClick(index) {
      cov_nuuju9ebg().f[26]++;
      cov_nuuju9ebg().s[66]++;
      if (index === this.getSelectedTabIndex()) {
        cov_nuuju9ebg().b[31][0]++;
        cov_nuuju9ebg().s[67]++;
        return;
      } else {
        cov_nuuju9ebg().b[31][1]++;
      }
      cov_nuuju9ebg().s[68]++;
      this.props.onSelect(index);
      // add the tab to the list of already shown tabs
      var shownTabs = (cov_nuuju9ebg().s[69]++, this.state.shownTabs);
      cov_nuuju9ebg().s[70]++;
      if (shownTabs.indexOf(index) === -1) {
        cov_nuuju9ebg().b[32][0]++;
        cov_nuuju9ebg().s[71]++;
        shownTabs = shownTabs.concat(index);
      } else {
        cov_nuuju9ebg().b[32][1]++;
      }
      cov_nuuju9ebg().s[72]++;
      this.tabSelected(index);
      cov_nuuju9ebg().s[73]++;
      this.setState({
        selectedTabIndex: index,
        shownTabs: shownTabs,
        focusedTabIndex: index
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_nuuju9ebg().f[30]++;
      var _ref5 = (cov_nuuju9ebg().s[79]++, this.props),
        large = _ref5.large,
        centered = _ref5.centered,
        showCloseIcon = _ref5.showCloseIcon,
        noBorder = _ref5.noBorder,
        additionalChild = _ref5.additionalChild,
        tabMode = _ref5.tabMode,
        useGoogleEnhancedTracking = _ref5.useGoogleEnhancedTracking,
        isLandingPage = _ref5.isLandingPage,
        useMainTitleBackgroundColor = _ref5.useMainTitleBackgroundColor,
        forceReRenderTab = _ref5.forceReRenderTab,
        currentTheme = _ref5.currentTheme;
      var _ref6 = (cov_nuuju9ebg().s[80]++, this.state),
        focusedTabIndex = _ref6.focusedTabIndex;
      var tabItems = (cov_nuuju9ebg().s[81]++, this.getTabs());
      var selectedTabIndex = (cov_nuuju9ebg().s[82]++, this.getSelectedTabIndex());
      var tabsToDisplay = (cov_nuuju9ebg().s[83]++, selectedTabIndex >= 0 ? (cov_nuuju9ebg().b[34][0]++, tabItems.map(function (item) {
        cov_nuuju9ebg().f[31]++;
        cov_nuuju9ebg().s[84]++;
        if (_this2.state.shownTabs.indexOf(item.index) === -1) {
          cov_nuuju9ebg().b[35][0]++;
          cov_nuuju9ebg().s[85]++;
          return null;
        } else {
          cov_nuuju9ebg().b[35][1]++;
        }
        cov_nuuju9ebg().s[86]++;
        if ((cov_nuuju9ebg().b[37][0]++, isLandingPage) && (cov_nuuju9ebg().b[37][1]++, useGoogleEnhancedTracking) && (cov_nuuju9ebg().b[37][2]++, !item.active)) {
          cov_nuuju9ebg().b[36][0]++;
          cov_nuuju9ebg().s[87]++;
          return null;
        } else {
          cov_nuuju9ebg().b[36][1]++;
        }
        cov_nuuju9ebg().s[88]++;
        return /*#__PURE__*/_react.default.createElement(_TabPanel.default, {
          showCloseIcon: showCloseIcon,
          key: "g-Tab-panel-".concat(item.index),
          index: item.index,
          active: item.active,
          onCloseTabs: function onCloseTabs() {
            cov_nuuju9ebg().f[32]++;
            cov_nuuju9ebg().s[89]++;
            return _this2.closeTabs();
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 350,
            columnNumber: 15
          }
        }, item.content);
      })) : (cov_nuuju9ebg().b[34][1]++, []));
      cov_nuuju9ebg().s[90]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        currentTheme: currentTheme,
        key: this.id,
        tabMode: tabMode,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 362,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(TabsList, {
        activeBorderRange: this.state.activeBorderRange,
        innerRef: this.tabsRef,
        currentTheme: currentTheme,
        centered: centered,
        noBorder: noBorder,
        onKeyUp: function onKeyUp(e) {
          cov_nuuju9ebg().f[33]++;
          cov_nuuju9ebg().s[91]++;
          return _this2.onKeyUp(e);
        },
        useMainTitleBackgroundColor: useMainTitleBackgroundColor,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 363,
          columnNumber: 9
        }
      }, tabItems.map(function (item) {
        cov_nuuju9ebg().f[34]++;
        cov_nuuju9ebg().s[92]++;
        return /*#__PURE__*/_react.default.createElement(_Tab.default, {
          buttonProps: item.buttonProps,
          centered: centered,
          large: large,
          key: "g-Tab-item-".concat(item.index),
          index: item.index,
          label: item.label,
          active: item.active,
          disabled: item.disabled,
          onSelect: _this2.handleClick.bind(_this2, item.index) // eslint-disable-line react/jsx-no-bind
          ,
          isFocused: item.index === focusedTabIndex,
          customRef: item.index === focusedTabIndex ? (cov_nuuju9ebg().b[38][0]++, _this2.activeTab) : (cov_nuuju9ebg().b[38][1]++, null),
          tabType: item.tabType,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 372,
            columnNumber: 13
          }
        });
      })), (cov_nuuju9ebg().b[39][0]++, this.isArrayContainNotNullValue(additionalChild)) && (cov_nuuju9ebg().b[39][1]++, /*#__PURE__*/_react.default.createElement(AdditionalChildWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 389,
          columnNumber: 11
        }
      }, additionalChild)), forceReRenderTab ? (cov_nuuju9ebg().b[40][0]++, tabsToDisplay[selectedTabIndex]) : (cov_nuuju9ebg().b[40][1]++, tabsToDisplay));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Tabs, "getDerivedStateFromProps", (cov_nuuju9ebg().s[17]++, function (nextProps, state) {
  cov_nuuju9ebg().f[14]++;
  cov_nuuju9ebg().s[18]++;
  return _objectSpread(_objectSpread({}, state), {}, {
    shownTabs: [].concat((0, _toConsumableArray2.default)(state.shownTabs), [nextProps.selectedTabIndex]),
    selectedTabIndex: state.selectedTabIndex,
    focusedTabIndex: state.focusedTabIndex
  });
}));
cov_nuuju9ebg().s[93]++;
Tabs.propTypes = {
  /** one or more tab elements */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** action that will be sent if the tab selection changed */
  onSelect: _propTypes.default.func,
  /** The initial selected Tab Index */
  selectedTabIndex: _propTypes.default.number,
  /** Large, I guess to put it big, I don't know yet */
  large: _propTypes.default.bool,
  /** indicate if the tabs will be centered */
  centered: _propTypes.default.bool,
  /** Boolean to show a Close button to close the panel content */
  showCloseIcon: _propTypes.default.bool,
  /** Boolean to show a bottom border */
  noBorder: _propTypes.default.bool,
  /**
   * This method will be called when a tab is selected along with an index
   * to be selected. If this method is not passed as props, the selectedTabIndex
   * will be selected from the state
   */
  onTabsChange: _propTypes.default.func,
  /** element to display between tab & tab items */
  additionalChild: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** The design of the tabs. FLAT is more fresh and modern. BLOCK is more prominent. */
  tabMode: _propTypes.default.oneOf(['FLAT', 'BLOCK']),
  /** Option to use google enhance tracking to push data to data layer */
  useGoogleEnhancedTracking: _propTypes.default.bool,
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /* True to set a background color of tabs same as pos theme config */
  useMainTitleBackgroundColor: _propTypes.default.bool,
  /** Tab will be re-rendered everytime it is switched from another tab, unless, it is only rendered once and kept regardless it is not selected */
  forceReRenderTab: _propTypes.default.bool,
  /** theme context */
  currentTheme: _propTypes.default.string,
  themeQueries: _utils.WithThemeQueriesType
};
cov_nuuju9ebg().s[94]++;
Tabs.defaultProps = {
  onSelect: function onSelect() {
    cov_nuuju9ebg().f[35]++;
  },
  selectedTabIndex: 0,
  large: true,
  centered: false,
  tabType: 'text',
  showCloseIcon: false,
  noBorder: false,
  onTabsChange: undefined,
  additionalChild: null,
  tabMode: 'FLAT',
  useGoogleEnhancedTracking: false,
  isLandingPage: false,
  useMainTitleBackgroundColor: false,
  forceReRenderTab: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  theme: {},
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _styledComponents.withTheme)(Tabs)));